import React from 'react';
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem } from '@mui/material';
import { useUpsertProcedureMutation, useGetProcedureTypesQuery } from '../../../../services/ConfigurationService';

export function AddProcedureDialog({ defaultCenterId, onSuccess }: { defaultCenterId: string; onSuccess?: () => void }) {
  const [open, setOpen] = React.useState(false);
  const [code, setCode] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [codeType, setCodeType] = React.useState('CPT');
  const [upsertProcedure, { isLoading }] = useUpsertProcedureMutation();
  const { data: procedureTypes = [] } = useGetProcedureTypesQuery();

  const handleSave = async () => {
    if (!code) return;
    const id = `${defaultCenterId}-${code}`;
    await upsertProcedure({ id, centerId: defaultCenterId, code, description, codeType: codeType || 'CPT' });
    setOpen(false);
    setCode('');
    setDescription('');
    setCodeType('CPT');
    if (onSuccess) onSuccess();
  };

  return (
    <React.Fragment>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Add Procedure
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Add Procedure</DialogTitle>
        <DialogContent>
          <TextField
            label="Code"
            value={code}
            onChange={e => setCode(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Description"
            value={description}
            onChange={e => setDescription(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            select
            label="Code Type"
            value={codeType}
            onChange={e => setCodeType(e.target.value)}
            fullWidth
            margin="normal"
          >
            {procedureTypes.map(option => (
              <MenuItem key={option} value={option}>{option}</MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} variant="outlined">Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary" disabled={isLoading}>Save</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
